function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M25,0C11.21,0,0,11.21,0,25s11.21,25,25,25,25-11.21,25-25S38.78,0,25,0Zm0,46c-11.58,0-21-9.42-21-21S13.42,4,25,4s21,9.42,21,21-9.42,21-21,21Z",
    style: {
      fill: "currentcolor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.57,13.52l-.07,22.94c0,1.46,1.68,2.28,2.83,1.37l14.4-11.47c.87-.7,.88-2.02,0-2.72l-14.33-11.47c-1.14-.91-2.83-.1-2.83,1.35Z",
    style: {
      fill: "none",
      stroke: "currentcolor",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.18d9cb3f.svg";
export { ForwardRef as ReactComponent };